import { useParams } from "react-router-dom";

import CalendarPage from "@/features/calendar/views/CalendarPage.tsx";
import useWorkspaceInformationStore from "@/features/workspaces/store/useWorkspaceInformationStore.tsx";

export const StudentsWorkspaceSchedule = () => {
  const { workspaceId } = useParams();
  const { data } = useWorkspaceInformationStore();

  return (
    <>
      {data && (
        <CalendarPage canMakeReservations={data.can_make_reservations} workspaceId={workspaceId} />
      )}
    </>
  );
};
